import { createBrowserHistory } from "history";

export const defaultHistory = createBrowserHistory();
